import { BaseEntity } from ".";
import { IGet_characters_character_id_roles_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";

export class CorporationRolesEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: number) {
    super(id, props);
    this._dataTypeName = "Character Corporation Roles";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_roles_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Id
      delete entity.properties["id"];
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      let role_array: Excel.CellValue[][] = [];
      if (props.roles) {
        for (const y of props.roles) {
          role_array.push([
            {
              type: Excel.CellValueType.string,
              basicValue: y.valueOf(),
            },
          ]);
        }
      }
      if (role_array.length) {
        entity.properties["roles"] = {
          type: Excel.CellValueType.array,
          elements: role_array,
        };
      }
      entity.text = `${role_array.length} roles for ${characterEntity?.props["name"]}`;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
